// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
import { BillingPlanStatus } from '@/billing/api/types';
import { FilterOption } from '@/components/filter-toggle-group';
import {
  CheckCircleOutlineRounded,
  EventAvailableOutlined,
  HourglassEmptyOutlined,
  HourglassTopOutlined,
  ListRounded,
} from '@/constants/hardfin-standard-icons';
import { createElement } from 'react';

export const PLAN_STATUS_CHIP_CONFIG: Record<
  BillingPlanStatus,
  {
    label: string;
    variant: 'outlined' | 'filled';
    color: 'default' | 'primary' | 'success' | 'warning';
  }
> = {
  PENDING: { label: 'Pending', variant: 'filled', color: 'warning' },
  CONFIRMED: { label: 'Confirmed', variant: 'outlined', color: 'primary' },
  ACTIVE: { label: 'Active', variant: 'filled', color: 'primary' },
  COMPLETE: { label: 'Complete', variant: 'outlined', color: 'success' },
};

export const PLAN_CARD_COLOR_TOKENS: Record<BillingPlanStatus, string> = {
  PENDING: 'warning.main',
  CONFIRMED: 'text.secondary',
  ACTIVE: 'primary.main',
  COMPLETE: 'success.main',
};

export type BillingPlanStatusFilter = BillingPlanStatus | 'all';

export const PLAN_STATUS_FILTER_OPTIONS: FilterOption<BillingPlanStatusFilter>[] =
  [
    {
      value: 'all',
      label: 'All',
      icon: createElement(ListRounded, { fontSize: 'small' }),
    },
    {
      value: 'PENDING',
      label: 'Pending',
      icon: createElement(HourglassEmptyOutlined, { fontSize: 'small' }),
    },
    {
      value: 'CONFIRMED',
      label: 'Confirmed',
      icon: createElement(EventAvailableOutlined, { fontSize: 'small' }),
    },
    {
      value: 'ACTIVE',
      label: 'Active',
      icon: createElement(HourglassTopOutlined, { fontSize: 'small' }),
    },
    {
      value: 'COMPLETE',
      label: 'Complete',
      icon: createElement(CheckCircleOutlineRounded, { fontSize: 'small' }),
    },
  ];

export const PLAN_PAGE_SIZE = 20;
